import styled from 'styled-components';
export const ThirdPartyLoginWrapper = styled.div.withConfig({
  displayName: "ThirdPartyLoginElementsstyles__ThirdPartyLoginWrapper",
  componentId: "sc-1dbc14d-0"
})(["display:flex;gap:12px;@media (max-width:425px){flex-wrap:wrap;}"]);